import { render, staticRenderFns } from "./ChaptersOfCourse.vue?vue&type=template&id=34d9a59a&scoped=true&"
import script from "./ChaptersOfCourse.vue?vue&type=script&lang=js&"
export * from "./ChaptersOfCourse.vue?vue&type=script&lang=js&"
import style0 from "./ChaptersOfCourse.vue?vue&type=style&index=0&id=34d9a59a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d9a59a",
  null
  
)

export default component.exports